import React, { useState, useEffect } from 'react';
import { Container } from 'reactstrap';
import { AdminService } from '../../services/AdminService';

// Import new component files
import FormLinkGenerator from './components/FormLinkGenerator';
import FormSubmissionsTable from './components/FormSubmissionsTable';

interface JotformData {
  clientName?: string;
  formName: string;
  resultLink: string;
  submissionDate: string;
  score_GAD_7: number;
  score_PHQ_9: number;
  score_AUDIT: number;
  score_DAST: number;
  client?: {
    _id: string;
    name: string;
    firstname: string;
    lastname: string;
    email: string;
    dateOfBirth?: string;
    providerName?: string;
    providerNPI?: string;
    memberId?: string;
    organizationName?: string;
  };
  clientId?: string;
}

const styles = {
  container: {
    padding: '20px',
    backgroundColor: '#fafafa'
  },
  pageHeader: {
    marginBottom: '1.5rem'
  },
  loadingContainer: {
    display: 'flex', 
    justifyContent: 'center', 
    alignItems: 'center', 
    marginBottom: '1rem'
  },
  loadingText: {
    fontSize: '1.125rem', 
    fontWeight: '500', 
    color: '#374151'
  },
  componentDivider: {
    margin: '2rem 0',
    height: '1px',
    backgroundColor: '#e5e7eb',
    width: '100%'
  }
};

const NewJotForm: React.FC = () => {
  const [jotformData, setJotformData] = useState<JotformData[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  // Fetch data when component mounts
  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoading(true);
        
        // Fetch form submissions
        const jotformResponse = await AdminService.getAllJotForms();
        if (jotformResponse.success && jotformResponse.data) {
          setJotformData(jotformResponse.data);
        }
      } catch (error) {
        console.error("Error loading data:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);

  return (
    <div className="animate__animated animate__fadeIn">
      <div className="page-content">
        <Container fluid>
          <div style={styles.container}>
            {/* Page Header */}
            <div style={styles.pageHeader}>
              <h1 style={{fontSize: '1.5rem', fontWeight: 'bold'}}>New Jot Form</h1>
              <p style={{fontSize: '0.875rem', color: '#6b7280', marginTop: '0.25rem'}}>Admin Only Page</p>
            </div>

            {isLoading && (
              <div style={styles.loadingContainer}>
                <div style={styles.loadingText}>Loading...</div>
              </div>
            )}

            {/* Form Link Generator Component */}
            <FormLinkGenerator />

            {/* Visual separator between components */}
            <div style={styles.componentDivider}></div>

            {/* Form Submissions Table Component */}
            <FormSubmissionsTable 
              jotformData={jotformData} 
              isLoading={isLoading} 
            />
          </div>
        </Container>
      </div>
    </div>
  );
};

export default NewJotForm;
